// extracted by mini-css-extract-plugin
module.exports = {"form":"SearchBar_form__wmcoC","input":"SearchBar_input__h_qxL","icon":"SearchBar_icon__d9_4D","button":"SearchBar_button__goHHI"};